import { useUsersStore } from "~/store/users/users.store";
import type { IHeaderNav, IIndexHeader } from "~/utils/interfaces/table-interfaces";
import type { IFooterActions } from "~/utils/interfaces/common-interfaces";
import { useLearningPathTrainingsStore } from "~/store/learning-path/learning-path-trainings.store";
import { BookingStatusEnum } from "~/utils/enums/bookings-events.enums";
import { UserSubscriptionStatusEnum } from "~/utils/enums/learning-path.enums";

export const useLearningPathTrainingsAttendees = () => {
  const { handleLearningPathTrainingsSessionsModal } = useLearningPathTrainingsStore();
  function getNav(): IHeaderNav[] {
    return [];
  }

  async function fetchNotExcludedUserLearningPath(
    userIdList: string[],
    context?: string,
    enableRolesFilters: boolean = true,
  ) {
    const usersStore = useUsersStore();
    // `null` means the store already surfaced the rejection.
    return (
      (await usersStore.fetchUsersNotExcluded({
        excludedUserIds: userIdList,
        context,
        enableRolesFilters,
      })) ?? undefined
    );
  }

  /** TODO: new headers for TC attendees
   * SCOPE: SettingScopesEnum.LearningPathAttendeesTab
   * */

  const headers = useState<IIndexHeader[]>(() => [
    {
      name: "Nom",
      sort: true,
      key: "fullname",
      minWidthPx: 180,
      maxWidthFr: 1,
      visible: true,
    },
    {
      name: "Statut",
      sort: true,
      key: "status",
      minWidthPx: 100,
      maxWidthFr: 1,
      visible: true,
    },
    {
      name: "Commentaire",
      sort: true,
      key: "comment",
      minWidthPx: 180,
      maxWidthFr: 1,
      visible: true,
    },
  ]);

  const footersActionsTrainingsAttendees: IFooterActions[] = [
    {
      name: "Inscrire à une session",
      logoName: "create",
      action: () => handleLearningPathTrainingsSessionsModal(true),
    },
  ];

  function statusMapping(value: string): { name: string; value: string; type: string } | undefined {
    return [
      {
        name: BookingStatusEnum.BOOKING_CANCELED,
        value: "Annulé",
        type: "light_red",
      },
      {
        name: BookingStatusEnum.BOOKING_REFUSED,
        value: "Refusé",
        type: "light_red",
      },
      {
        name: BookingStatusEnum.BOOKING_NO_SHOW,
        value: "Absent",
        type: "light_grey",
      },
      {
        name: UserSubscriptionStatusEnum.BOOKED,
        value: "Actif",
        type: "light_green",
      },
      {
        name: UserSubscriptionStatusEnum.NOT_BOOKED,
        value: "À inscrire",
        type: "grey",
      },
      {
        name: UserSubscriptionStatusEnum.ERROR,
        value: "Erreur",
        type: "light_red",
      },
    ].find((s) => s.name === value);
  }

  return {
    fetchNotExcludedUserLearningPath,
    headers,
    getNav,
    footersActionsTrainingsAttendees,
    statusMapping,
  };
};
